// import { header } from './utils';
import { WhiteLabel } from '../stores/types/whitelabel.interface';
import { API_KEYS, Api } from './base.api';

export const whiteLabelsApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    fetchWhiteLabels: builder.query<WhiteLabel[], void>({
      query: () => ({
        url: `/internal/core/v2/${API_KEYS.WHITELABELS}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useFetchWhiteLabelsQuery } = whiteLabelsApi;
